import { h, ComponentChildren } from "preact";
import "./errorbar.scss";
import { IconSvg } from "./iconsvg";

interface Props {
    children: ComponentChildren
    icon?: string;
    class?: string;
}

export const Errorbar = (props: Props) => (
    <div class={"material-errorbar" + (props.class ? (" " + props.class) : "")}>
        {
            props.icon &&
            IconSvg(props.icon)
        }
        {props.children}
    </div>
)

